import React from "react";
import Grid from "../../partials/content/Grid";
import { Table } from "react-bootstrap";
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory, { textFilter,numberFilter } from 'react-bootstrap-table2-filter';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator'
import { getMaster,getRequestSummaryByImplant,getRequestSummary,createOrder,USDFormat} from "../../crud/auth.crud";
import {
  Portlet,
  PortletBody,
} from "../../partials/content/Portlet";
import { Tooltip } from "@material-ui/core";
 import { IconButton } from '@material-ui/core';
 import EditIcon from '@material-ui/icons/Edit';
 import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
 import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
 import { Link } from "react-router-dom";
 import TextField from '@material-ui/core/TextField';
 import Alert from '@material-ui/lab/Alert'
 import Button from '@material-ui/core/Button';
 
 import CircularProgress from '@material-ui/core/CircularProgress';
import Icon from '@material-ui/core/Icon';
import Chip from '@material-ui/core/Chip';
export default class Account extends React.Component {

  defaultSorted = [{
    dataField: 'accountName',
    order: 'desc'
  }];


  state = {
    accounts:[],
    allAccounts:[],
    businessEntities:[],
    columns :this.columns,
    defaultSorted: this.defaultSorted,
    implants:[],
    allimplants:[],
    summaries:[],
    isLoading:false,
    status: {flag:false, statusColor:'',statusMessage:'',loading:false},
    total:0,
    implantName:'Summary',
  }



  handleChange=(e,summary)=>{
     console.log("handle chnage ::::",summary);
    let cost = parseFloat(summary.productPrice) * (parseFloat(e.target.value)+summary.totalQuantity);
    this.setState({[`summary_${summary.productKey}`]:e.target.value});
    let alllist = this.state.summaries;
    let productIndex = alllist.findIndex(el => el.productKey == summary.productKey);
    alllist[productIndex] = {...alllist[productIndex], totalCost: cost};

    let total = 0;
    alllist.map((asd)=>{
      total = parseInt(total) + parseInt(asd.totalCost);
    })
    this.setState({summaries:alllist,total:total});

  }

  implantChange=(id,name)=>{

    this.setState({isLoading:true,implantName:name +' Summary',summaries:[],status:{flag:false, statusColor:'',statusMessage:'',loading:false}});
    getRequestSummary(id).then(response => response.data)
    .then(async (data) => {
      console.log("summary:::::::::",data);
      let bgColor = 'white';
      let fontColor = 'black';
      let total = 0;
      data.map((dt)=>{
        if(dt.currentStocks===0)
        {
          dt.bgColor = 'red';
          dt.fontColor = 'white';
      		dt.stockStatus = 'No Stock';
        }
         else if(parseInt(dt.currentStocks)-parseInt(dt.totalProcedures)>5 && parseInt(dt.currentStocks)-parseInt(dt.totalProcedures)<10)
        {
          dt.bgColor = 'yellow';
          dt.fontColor = 'black';
          dt.stockStatus = 'Minimum Stock';
        }
        else if(parseInt(dt.currentStocks)-parseInt(dt.totalProcedures)>10)
        {
          dt.bgColor = 'white';
          dt.fontColor = 'black';
          dt.stockStatus = null;
        }
        dt.totalCost = parseInt(dt.totalQuantity) * parseInt(dt.productPrice);
        total = parseInt(total) + parseInt(dt.totalCost);

      })
      this.setState({summaries:data,total:total,isLoading:false});

     });
     
  }

 placeOrder=()=>
 {
  //console.log("place order");
  this.setState({status:{flag:true, statusColor:'info',statusMessage:'Processing your request',loading:true}});
  let allsummarries  = this.state.summaries;
  let falseCount = false;
  let productSummaries = [];
  let order ={};
  let implantTypeKey ='';
  allsummarries.map((sum)=>{
    implantTypeKey=sum.implantTypeKey;
    //if(this.state[`summary_${sum.productKey}`]===null || this.state[`summary_${sum.productKey}`]===undefined)
    //{
    //  falseCount=true;
    //}
    //else
    //{
    let orderQty = sum.totalQuantity;

      if(this.state[`summary_${sum.productKey}`]!==null && this.state[`summary_${sum.productKey}`]!==undefined && this.state[`summary_${sum.productKey}`]!=="0")
      {
        console.log(this.state[`summary_${sum.productKey}`]);
        orderQty = parseInt(this.state[`summary_${sum.productKey}`])+parseInt(sum.totalQuantity);
      }
      

        productSummaries.push({
          productKey:sum.productKey,
          totalQuantity:orderQty,
          productPrice: sum.productPrice,
          implantTypeKey: sum.implantTypeKey
        });
      //
      //}
   // }

  })
  //console.log("final :::::",productSummaries);
 // if(falseCount)
  //{
  //  console.log("validation ::::missing");
  //  this.setState({status:{flag:true, statusColor:'error',statusMessage:'Missing required quantities. Fill up the quantities for all the products and try again',loading:false}});
  //  
  //}
  //else
  //{


    order.productSummaries = productSummaries;
    order.implantTypeKey = implantTypeKey;
    createOrder(order)
    .then(response => response.data)
    .then((data) => {
          
          this.setState({status:{flag:true, statusColor:'success',statusMessage:'Your order has been placed successfully and an email sent to Implant Sales Representative.',loading:false}});
          
    })
  //}

  getRequestSummaryByImplant().then(response => response.data)
    .then(async (data) => {
     let implants = data;
    implants.map((imp)=>{
      this.state.allimplants.filter(x=>x.implantTypeKey===imp.implantTypeKey).map((m)=>{
        imp.implantName = m.implantName;
      })
    })
     this.setState({ implants: implants })
      //alert('Business found:'+data.length)

     });

 }

  async componentDidMount()
  {
    
     await getMaster("implant").then(response => response.data)
        .then((data) => {
          this.setState({ allimplants: data })
          //console.log(this.state.users)
         })

    await getRequestSummaryByImplant().then(response => response.data)
    .then(async (data) => {
     let implants = data;
    implants.map((imp)=>{
      this.state.allimplants.filter(x=>x.implantTypeKey===imp.implantTypeKey).map((m)=>{
        imp.implantName = m.implantName;
      })
    })
     this.setState({ implants: implants })
      //alert('Business found:'+data.length)

     });

     /*
    await getRequestSummary().then(response => response.data)
    .then(async (data) => {
      console.log("summary:::::::::",data);
      let bgColor = 'white';
      let fontColor = 'black';
      let total = 0;
      data.map((dt)=>{
        if(dt.currentStocks===0)
        {
          dt.bgColor = 'red';
          dt.fontColor = 'white';
      		dt.stockStatus = 'No Stock';
        }
         else if(parseInt(dt.currentStocks)-parseInt(dt.totalProcedures)>5 && parseInt(dt.currentStocks)-parseInt(dt.totalProcedures)<10)
        {
          dt.bgColor = 'yellow';
          dt.fontColor = 'black';
          dt.stockStatus = 'Minimum Stock';
        }
        else if(parseInt(dt.currentStocks)-parseInt(dt.totalProcedures)>10)
        {
          dt.bgColor = 'white';
          dt.fontColor = 'black';
          dt.stockStatus = null;
        }
        dt.totalCost = parseInt(dt.totalQuantity) * parseInt(dt.productPrice);
        total = parseInt(total) + parseInt(dt.totalCost);

      })
      this.setState({summaries:data,total:total});

     });
     */

     
  }
  render() {
    return (
      <>

         <div className="row">
        
        <div className="col-xl-12">
          <div className="row">
           {this.state.implants.map((imp,index) => (
            <div className="col-lg-3" key={'imp'+index} >
              
                <Portlet className="kt-portlet--border-bottom-brand" style={{ cursor: 'pointer' }} onClick={()=>this.implantChange(imp.implantTypeKey,imp.implantName)} >
                  <PortletBody fluid={true}>
                    <div className="kt-widget26" >
                      
                      <div className="kt-widget26__content">
                        <span className="kt-widget26__number" > 
                         
                          {imp.total}
                         
                        </span>
                        <span className="kt-widget26__desc">{imp.implantName}</span>
                      </div>
                      
                    </div>
                  </PortletBody>
                </Portlet>
           
             </div>
            ))}
            
          </div>
        </div>
        
        
      </div>

        <div className="row">
          <div className="col-md-12">
          {/*<Grid beforeCodeTitle="Sumamry" jsCode="true" createPath="/createaccount">
              <div className="kt-section">
            <BootstrapTable
              bootstrap4
              keyField="accountKey"
              data={ this.state.accounts }
              columns={ this.state.columns }
              defaultSorted={ this.state.defaultSorted } 
              filter={ filterFactory() }
              pagination={ paginationFactory()}
              paginationSize={100}
            />
           </div>
           </Grid>*/}
          <Grid beforeCodeTitle={this.state.implantName} jsCode="true">
              <div className="kt-section">
                {this.state.isLoading && (
                        <div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
                          <Alert severity={'info'} icon={this.state.status.loading && <CircularProgress size={15} />}>&nbsp;&nbsp;{'Loading...'}</Alert>      
                        </div>
                          )}
                          {this.state.implantName.toLowerCase()==='summary' && 
                           <div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
                          <Alert severity={'info'}>&nbsp;&nbsp;{'Please select any implant...'}</Alert>      
                        </div>
                          }
                           {this.state.summaries !==null && this.state.summaries.length===0 && this.state.implantName.toLowerCase()!=='summary' &&
                           <div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
                          <Alert severity={'info'}>&nbsp;&nbsp;{'No Records found...'}</Alert>      
                        </div>
                          }
                 {this.state.summaries !==null && this.state.summaries.length>0 && 
                 <Table bordered>
                  <thead>
                    <tr>
                      
                      <th className="align-top">Item #</th>
                      <th className="align-top">Description</th>
                      <th className="align-top" style={{width:'100px',whiteSpace:'nowrap'}}>Price</th>
                      <th className="align-top">Stock in hand</th>
                      <th className="align-top">Staged Procedures</th>
                      <th className="align-top">Staged Inventory</th>
                      <th className="align-top">Additional Qty</th>
                      <th className="align-top" style={{width:'50px',whiteSpace:'nowrap'}}>Cost</th>
                      <th className="align-top">Stock Status</th>
                      
                    </tr>
                  </thead>
                  <tbody>
                  {this.state.summaries.map((sum,index) => (
                    <tr style={{fontSize:14}} key={'aaa'+index}>
                     
                      <td className="align-middle">{sum.productCode}</td>
                      <td className="align-middle">{sum.productName}</td>                  
                      <td className="align-middle" style={{width:'50px',whiteSpace:'nowrap',color:'green',fontWeight:'bold'}}>{USDFormat(sum.productPrice)}</td>
                      <td className="align-middle">{sum.currentStocks}</td>
                      <td className="align-middle">{sum.totalProcedures}</td>
                      <td className="align-middle">{sum.totalQuantity}</td>
                      <td className="align-middle"><TextField
                              margin="normal"
                              className="kt-width-full"
                              type={'number'}
                              name={sum.productKey}                                                     
                              onChange={(e)=>this.handleChange(e,sum)}
                              value={this.state[`summary_${sum.productKey}`]}     
                              variant="outlined" 
                              InputProps={{
                                inputProps: { min: 0,
                                max: 100,
                                step: 1,
                                onKeyDown: (event) => {
                                  event.preventDefault();
                                }, }
                              }}                     
                          /></td>
                       <td className="align-middle" style={{width:'50px',whiteSpace:'nowrap',color:'green',fontWeight:'bold'}}>{sum.totalCost!==null && sum.totalCost!==undefined && 
                       <>
                        {USDFormat(sum.totalCost)}</>}
                       </td>
                       <td className="align-middle">{sum.stockStatus!==null && sum.stockStatus!==undefined &&<Chip size={'small'} label={sum.stockStatus} style={{backgroundColor : sum.bgColor,color:sum.fontColor, fontWeight:'bold'}} />}</td>
                    </tr>
                    ))}
                    <tr>
                      <td className="align-middle"></td>
                      <td className="align-middle"></td>
                      <td className="align-middle"></td>
                      <td className="align-middle"></td>
                      <td className="align-middle"></td>
                      <td className="align-middle"></td>
                      <td className="text-right" style={{width:'50px',whiteSpace:'nowrap',color:'black',fontWeight:'bold'}}>Total</td>
                      <td className="align-middle" style={{width:'50px',whiteSpace:'nowrap',color:'green',fontWeight:'bold'}}>{USDFormat(this.state.total)}</td>
                      <td className="aling-middle"></td>
                    </tr>
                </tbody>
                </Table>
              }
              </div>

              {this.state.summaries!==null !== null && this.state.summaries.length >0 && (
                      <Button
                        variant="outlined"
                        color="primary"
                        endIcon={<Icon>send</Icon>}
                        onClick={this.placeOrder}
                        style={{'margin':'5px'}}
                        >
                        Place Order
                      </Button>
                    )}
                      {this.state.status.flag && (
                        <div style={{alignItems: "center",display: 'flex', justifyContent: 'center'}}>                            
                          <Alert severity={this.state.status.statusColor} icon={this.state.status.loading && <CircularProgress size={15} />}>&nbsp;&nbsp;{this.state.status.statusMessage}</Alert>      
                        </div>
                          )}
                        

              
           </Grid>
                  
          </div>
         
        </div>

      

       
      </>
    );
  }
}
